import report from './report';

const sms = {
  report: report,
};

export * from "./smscrud/SmsCreate";

export default sms;